import React from "react";
import classNames from "classnames";

export default class Slider extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showLeftController: false,
			showRightController: false,
			showLeftBorder: false,
			showRightBorder: true,
			offsetSlider: 0,
		};
	}

	static defaultProps = {
		items: [],
	};

	slowMotion(multiple) {
		let offsetForTimer = 40;
		this.timerObject = setInterval(() => {
			let wrapperWidth = this.refs.sliderWrapper.offsetWidth;
			let sliderWidth = this.refs.slider.offsetWidth;
			let diff = sliderWidth - wrapperWidth;
			let nextValueOffset;
			if (multiple) {
				nextValueOffset =
					this.state.offsetSlider + offsetForTimer <= diff
						? this.state.offsetSlider + offsetForTimer
						: diff;
			} else {
				nextValueOffset =
					this.state.offsetSlider - offsetForTimer < 0
						? 0
						: this.state.offsetSlider - offsetForTimer;
			}
			this.setState({
				offsetSlider: nextValueOffset,
			});
			this.refs.slider.style.left = -1 * nextValueOffset + "px";
			if (nextValueOffset == diff || nextValueOffset == 0) {
				clearInterval(this.timerObject);
			}
		}, 500);
	}

	toNextItem() {
		clearInterval(this.timerObject);
		let wrapperWidth = this.refs.sliderWrapper.offsetWidth;
		let sliderWidth = this.refs.slider.offsetWidth;
		let classes = this.props.classes;
		let diff = sliderWidth - wrapperWidth;
		let totalWidth = wrapperWidth + this.state.offsetSlider;
		let currentWidth = 0;
		let movedWidth = 0;
		let nextItemWidth = 0;
		let defaultMargin = parseInt(
			getComputedStyle(this.refs.slider.querySelector(`.${classes.sliderItem}`)).marginRight
		);
		let counterItem = 0;
		let arrayItems = [...this.refs.slider.querySelectorAll(`.${classes.sliderItem}`)];
		arrayItems.map((item, index) => {
			if (currentWidth + item.offsetWidth <= totalWidth) {
				currentWidth += item.offsetWidth + defaultMargin;
			} else {
				if (!movedWidth) {
					movedWidth = currentWidth + item.offsetWidth - totalWidth;
					counterItem = index;
					currentWidth = Number.MAX_VALUE;
				} else {
					if (nextItemWidth == 0) {
						nextItemWidth = defaultMargin + item.offsetWidth;
					}
				}
			}
			return item.offsetWidth;
		});
		if (movedWidth < 100) {
			movedWidth += nextItemWidth;
		}

		let nextValueOffset = this.state.offsetSlider + movedWidth;

		this.setState({
			offsetSlider: nextValueOffset,
			showLeftBorder: true,
			showRightBorder: false,
		});
		this.refs.slider.style.transform = "translateX(" + -1 * nextValueOffset + "px)";
	}

	toPreviousItem() {
		clearInterval(this.timerObject);
		let wrapperWidth = this.refs.sliderWrapper.offsetWidth;
		let classes = this.props.classes;
		let sliderWidth = this.refs.slider.offsetWidth;
		let diff = sliderWidth - wrapperWidth;
		let previousWidth = this.state.offsetSlider;
		let currentWidth = 0;
		let previousItemWidth = 0;
		let movedWidth = 0;
		let defaultMargin = parseInt(
			getComputedStyle(this.refs.slider.querySelector(`.${classes.sliderItem}`)).marginRight
		);
		[...this.refs.slider.querySelectorAll(`.${classes.sliderItem}`)].map((item, index) => {
			if (currentWidth + item.offsetWidth <= previousWidth) {
				currentWidth += item.offsetWidth + defaultMargin;
				previousItemWidth = item.offsetWidth;
			} else {
				if (!movedWidth) movedWidth = previousWidth - currentWidth;
			}
			return item.offsetWidth;
		});
		if (movedWidth < 100) {
			movedWidth = movedWidth + previousItemWidth + defaultMargin;
		}
		let nextValueOffset =
			this.state.offsetSlider - movedWidth > 0 ? this.state.offsetSlider - movedWidth - 1 : 0;

		this.setState({
			offsetSlider: nextValueOffset,
			showLeftBorder: false,
			showRightBorder: true,
		});
		this.refs.slider.style.transform = "translateX(" + -1 * nextValueOffset + "px)";
	}

	stopMotion() {
		clearInterval(this.timerObject);
	}

	componentDidUpdate() {
		let wrapperWidth = this.refs.sliderWrapper.offsetWidth;
		let sliderWidth = this.refs.slider.offsetWidth;
		let diff = sliderWidth - wrapperWidth;

		if (this.state.showLeftController !== !!this.state.offsetSlider)
			this.setState({
				showLeftController: !!this.state.offsetSlider,
			});
		if (
			this.state.showRightController !==
			(diff > 0 && this.state.offsetSlider < diff && this.props.items.length > 1)
		)
			this.setState({
				showRightController:
					diff > 0 && this.state.offsetSlider < diff && this.props.items.length > 1,
			});
	}

	componentDidMount() {
		this.forceUpdate();
	}

	render() {
		let classes = this.props.classes;

		return (
			<React.Fragment>
				<div
					className={classNames(classes.sliderController, classes.sliderControllerPrev, {
						[classes.sliderControllerIsHide]: !this.state.showLeftController,
						[classes.sliderControllerShowBorder]: this.state.showLeftBorder,
					})}
					onClick={() => this.state.showLeftController && this.toPreviousItem()}
				>
					<div className={classes.sliderControllerItem}>
						<span className="icon24 icon-arrow-1-left" />
					</div>
				</div>
				<div ref="sliderWrapper" className={classes.sliderWrapper}>
					<div className={classes.slider} ref="slider">
						{this.props.items}
					</div>
				</div>
				<div
					className={classNames(classes.sliderController, classes.sliderControllerNext, {
						[classes.sliderControllerIsHide]: !this.state.showRightController,
						[classes.sliderControllerShowBorder]: this.state.showRightBorder,
					})}
					onClick={() => this.state.showRightController && this.toNextItem()}
				>
					<div className={classes.sliderControllerItem}>
						<span className="icon24 icon-arrow-1-right" />
					</div>
				</div>
			</React.Fragment>
		);
	}
}
